<template>
  <span>{{ text }}</span>
</template>

<script>
import { PrefectureModel } from '@/constants/prefecture'
export default {
  name: 'AppPrefecture',
  props: {
    prefecture: {
      type: Object, // PrefectureModel
      default: null,
    },
    id: {
      type: String, // 01-47
      default: null,
    },
  },
  computed: {
    text() {
      const prefecture = this.prefecture || new PrefectureModel({ id: this.id })
      return prefecture.name
    },
  },
}
</script>

<style></style>
